import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { axiosGet } from "../../api/Axios";

export const getAllWaitingList = createAsyncThunk(
  "/admin/waitList/getAllNewsLetterSubscribers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosGet<IWaitingList[]>(
        `/admin/waitList/getAllWaitList`
      );
      return response; // Return the user profile data
    } catch (error) {
      return rejectWithValue(error); // Return the error message
    }
  }
);

const initialState: IWaitingListSliceProp = {
  errors: [],
  isError: false,
  isApiLoading: true,
  list: [],
};

export const waitingListSlice = createSlice({
  name: "waitingList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getAllWaitingList.pending, (state) => {
        state.isApiLoading = true;
        state.isError = false;
      })
      .addCase(getAllWaitingList.fulfilled, (state, action) => {
        state.isApiLoading = false;
        state.list = action.payload;
      })
      .addCase(getAllWaitingList.rejected, (state, action) => {
        state.isApiLoading = false;
        state.isError = true;
        state.errors = [action.payload as string];
      });
  },
});

export const {} = waitingListSlice.actions;

export default waitingListSlice.reducer;
